import * as I18n from 'i18n-js';
import * as React from 'react';
import { shuffle } from 'lodash';
import Listing, { APIListingsResponse, APIListing } from './listing';
import mapAJAXToProps from '../map_ajax_to_props';

import APIRequest from '../api_request';
import ListingRow from './listing_row';
import buildSearchParams from './build_search_params';
import constants from '../shared/constants';
import URLHelpers from '../shared/url_helpers';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

const NON_PARTICIPATING_COUNTRIES = ['US', constants.EVERYWHERE_CODE];
const NUM_LISTINGS = 12;
const COUNTRIES_THAT_REQUIRE_THE = ['GB'];

function countryOptedOut(countryCode) {
  // "Everywhere" region (XX) does not have country code
  if (!countryCode) { return true; }
  return !!(NON_PARTICIPATING_COUNTRIES.indexOf(countryCode) + 1);
}

function countryRequiresThe(countryCode) {
  return COUNTRIES_THAT_REQUIRE_THE.includes(countryCode);
}

interface IProps extends IUserContext {
  params?: object;
  minimumListings?: number;
  total?: number;
  listings?: Listing[];
  error?: boolean;
}

class RegionalListings extends React.Component<IProps, null> {
  static defaultProps = {
    minimumListings: 4,
    error: false,
  };

  get marketplaceHref() {
    return `/marketplace?item_region=${this.props.user.countryCode}`;
  }

  renderHeader() {
    const iconClassName = 'flag-icon-header__icon ' +
      `flag-icon flag-icon-${this.props.user.countryCode.toLowerCase()}`;

    const country = I18n.t(`countries.${this.props.user.countryCode}`);
    const titleKey = countryRequiresThe(this.props.user.countryCode) ?
      'discovery.regionalListings.titleWithThe' :
      'discovery.regionalListings.title';

    const title = I18n.t(titleKey, { country });

    return (
      <div className="flag-icon-header">
        <span className={iconClassName}></span>
        {title}
      </div>
    );
  }

  render() {
    if (this.props.error) { return null; }
    if (countryOptedOut(this.props.user.countryCode)) { return null; }

    return (
      <div className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
        <ListingRow
          listings={this.props.listings}
          expectedCount={NUM_LISTINGS}
          trackName="regionalListings"
          titleElement={this.renderHeader()}
          ctaText={I18n.t('discovery.regionalListings.viewMore')}
          ctaTarget={this.marketplaceHref}
          minListings={this.props.minimumListings}
          alwaysShowCTA
          largeTiles
        />
      </div>
    );
  }
}

function buildParams(params = {}, countryCode) {
  return buildSearchParams(
    {
      ...params,
      item_region: countryCode,
      condition: constants.USED_CONDITION,
    },
  );
}

function fetcher(props: IProps) {
  return new Promise((resolve) => {
    if (countryOptedOut(props.user.countryCode)) {
      resolve({});
    } else {
      const req = APIRequest.V3.get(URLHelpers.listingsGridPath(), buildParams(props.params, props.user.countryCode));
      req.then((data) => {
        const resp = data as APIListingsResponse;
        const randomizedListings = shuffle(resp.listings).slice(0, NUM_LISTINGS) as APIListing[];
        const randomizedListingModels = randomizedListings.map(listing => new Listing(listing));

        resolve({
          total: data.total,
          listings: randomizedListingModels,
        });
      }).fail(() => {
        resolve({ error: true });
      });
    }
  });
}

export default withUserContext(mapAJAXToProps(fetcher)(RegionalListings, 'RegionalListings'));



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/regional_listings.tsx